'use client';

import React from 'react';
import { CompanyValueType } from '@/types/company-detail';
import { SeoHotLinksType } from '@/types/common';
import Tabs from './Tabs';
import GeneralSection from '../GeneralSection';
import PanoramaTabPanel from './PanoramaTabPanel';
import OpportunitiesAndChallengesTabPanel from './OpportunitiesAndChallengesTabPanel';
import CultureTabPanel from './CultureTabPanel';
import JobSeekingGuideTabPanel from './JobSeekingGuideTabPanel';
import HotJobsTabPanel from './HotJobsTabPanel';
import LinksContainer from '../LinksContainer';
import { ACTIVE_TABS } from '@/constants/company-detail';

interface Props {
  companyDetail: CompanyValueType;
  seoHotLinks: SeoHotLinksType;
}

const CompanyDetail = (props: Props) => {
  const {
    seoHotLinks,
    companyDetail: {
      seo_content: seoContent,
      name: companyName,
      id: companyId,
    },
  } = props;
  const [selectedTab, setSelectedTab] = React.useState(ACTIVE_TABS[0].en);
  return (
    <div className="mt-10">
      <Tabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <GeneralSection
        marginTop="my-8"
        resumeEvaluationTitle="你的简历能通过筛选吗？"
      >
        <PanoramaTabPanel
          show={selectedTab === ACTIVE_TABS[0].en}
          companyName={companyName}
          whatToDoData={seoContent['这家公司']}
          partnerData={seoContent['公司有哪些']}
          competitionData={seoContent['在市场中面临怎样的竞争']}
          latestNewsData={seoContent['公司最新动态']}
        />
        <OpportunitiesAndChallengesTabPanel
          show={selectedTab === ACTIVE_TABS[1].en}
          transformationData={seoContent['应对转型']}
          companyRiskData={seoContent['公司风险']}
          companyOpportunityData={seoContent['公司机遇']}
        />
        <CultureTabPanel
          show={selectedTab === ACTIVE_TABS[2].en}
          teamCultureData={seoContent['团队文化与工作方式']}
          matchingData={seoContent['求职者匹配度']}
          keyTeamData={seoContent['哪些团队值得']}
        />
        <JobSeekingGuideTabPanel
          show={selectedTab === ACTIVE_TABS[3].en}
          strategyData={seoContent['如何制定策略'] || {}}
          submissionSuccessRateData={seoContent['提高投递率'] || {}}
          precautionsData={seoContent['求职注意事项'] || {}}
        />
        <HotJobsTabPanel
          companyId={companyId}
          show={selectedTab === ACTIVE_TABS[4].en}
        />
        <div className="mt-8">
          <LinksContainer seoHotLinks={seoHotLinks} />
        </div>
      </GeneralSection>
    </div>
  );
};

export default CompanyDetail;
